<div class="container-fluid">

  <div class="header-container">
    <div class="iso-header ">
      {{ 'bikeshop.shop_setup.card_headers.rental_affiliates' | translate }}
    </div>
    <div>
      <button (click)="addNewAffiliate()" class="iso-round-button"
              style="width: 200px;">{{'bikeshop.rentals.affiliates.add' | translate}}</button>
    </div>
  </div>

  <div *ngIf="(!affiliates || affiliates.length === 0) && !loadingAffiliates" class="empty-state">
    <div class="empty-state-icon"><span class="fa fa-building-o"></span></div>
    <div class="empty-state-header">{{ 'bikeshop.rentals.affiliates.empty_state_header' | translate }}</div>
    <div class="empty-state-text">{{ 'bikeshop.rentals.affiliates.empty_state_text' | translate }}</div>
  </div>
  <div *ngIf="loadingAffiliates" style="margin-top: 16px;margin-bottom: 16px;display: flex;justify-content: center;">
    <p-progressSpinner [style]="{ width: '30px', height: '30px' }" animationDuration=".5s">
    </p-progressSpinner>
  </div>


  <div *ngIf="affiliates && affiliates.length > 0" class="affiliate-container">
    <div *ngFor="let affiliate of affiliates" class="affiliate" (click)="openAffiliate(affiliate)">
      <div class="title">{{affiliate.affiliateName}}</div>
      <div class="info"><span class="fa fa-user"></span>
        <div>{{affiliate.contactPerson}}</div>
      </div>
      <div class="info"><span class="fa fa-envelope"></span>
        <div>{{affiliate.contactEmail}}</div>
      </div>
      <div class="info"><span class="fa fa-phone"></span>
        <div>{{affiliate.contactNumber}}</div>
      </div>
      <div class="info"><span class="fa fa-percent"></span>
        <div
          *ngIf="affiliate.payCommission && affiliate.commissionPercentage">{{affiliate.commissionPercentage.toFixed(2)}}
          %
        </div>
        <div *ngIf="!(affiliate.payCommission && affiliate.commissionPercentage)">---</div>
      </div>
      <div class="info" *ngIf="affiliate.stripeAccountID"><span class="fa fa-cc-stripe"></span>
        <div>{{ 'bikeshop.rentals.affiliates.stripe_connected' | translate }}</div>
      </div>
    </div>
  </div>

</div>


<p-sidebar #NavSideBar [(visible)]="showAffiliate" position="right"
           [style]="{width:'650px', background: '#FAFAFA', 'overflow-x': 'auto'}"
           (onHide)="getAffiliates(); NavSideBar.destroyModal()">
  <div *ngIf="showAffiliate">
    <app-rental-affiliate-config [affiliate]="selectedAffiliate" [hasStripeConfigured]="hasStripeConfigured"
                                 (close)="closePanel($event)"></app-rental-affiliate-config>
  </div>
</p-sidebar>
